<template>
  <c-box>
    <c-box
      position="sticky"
      top="calc(84px)"
      background-color="white"
      z-index="10"
      box-shadow="10px 0px 0px white, -10px 0px 0px white"
    >
      <c-flex
        align-items="center"
        justify-content="space-between"
      >
        <c-button
          variant="ghost"
          width="30px"
          min-width="30px"
          height="30px"
          margin="0"
          padding="0"
          margin-right="16px"
          @click="$router.push({
            ...$route,
            name: 'nutri.meal-plan.meal-plan-schedule.detail',
          })
          "
        >
          <c-box
            :width="['12px', '15px']"
            :height="['12px', '15px']"
          >
            <inline-svg
              :src="require('@/assets/icons/icon-arrow-down.svg')"
              height="100%"
              width="100%"
              fill="#008C81"
              style="transform: rotate(90deg);"
            />
          </c-box>
        </c-button>
        <TabsMealPlan 
          mode="edit"
          :tabs="subTabs"
          :is-loading="isLoadingSave || saveState === null"
        />
        <c-tooltip
          :label="iconCloud.text"
          placement="bottom"
        >
          <c-box
            :width="['35px']"
            :height="['35px']"
            margin-right="16px"
            flex-shrink="0"
            :class="iconCloud.state === 'loading' ? 'animate-spin' : ''"
          >
            <inline-svg
              :src="iconCloud.icon"
              height="100%"
              width="100%"
              fill="#008C81"
            />
          </c-box>
        </c-tooltip>
        <BaseButton
          :left-svg-icon="require('@/assets/icons/icon-save.svg')"
          left-svg-icon-color="white"
          :disabled="!isValidAllMealPlanForm || saveState === null || isLoadingSave"
          @click="onSaveDraft"
        >
          Simpan
        </BaseButton>
      </c-flex>

      <c-flex
        width="100%"
        flex-direction="column"
        margin-top="16px"
      >
        <c-flex
          v-if="!isProfilGiziValid"
          margin-top="16px"
          background-color="danger.50"
          padding="6px 10px"
          border-radius="8px"
          align-items="center"
          gap="10px"
          margin-bottom="16px"
        >
          <inline-svg
            :src="require('@/assets/icons/icon-circle-warn.svg')"
            height="20px"
            width="20px"
            fill="#D32737"
          />
          <c-text
            color="danger.400"
            font-size="14px"
          >
            Selesaikan formulir Profil Gizi terlebih dahulu untuk mengaktifkan formulir ini
          </c-text>
        </c-flex>

        <!-- tag #[[250318]] simple nutritional info -->
        <c-flex
          gap="8px"
          padding-block="24px"
          position="sticky"
          top="83px"
          background-color="white"
          z-index="20"
          :box-shadow="boxShadowSimpleNutrionalInfo"
        >
          <c-box
            v-for="[nutri, nutriValue] in Object.entries(getSimpleNutritionalInfo).toSorted((a, b) => a - b)"
            :key="nutri"
            padding-right="12px"
            width="100%"
          >
            <CardInfoSimpleNutritionalProperty
              :title="nutri"
              :requirement="nutriValue.target"
              :current="nutriValue.current"
              :unit="nutriValue.unit"
            />
          </c-box>
        </c-flex>
      </c-flex>
    </c-box>
    <!-- DEV ONLY -->
    <!--    <c-box padding="16px">-->
    <!--      <c-box-->
    <!--        background-color="green"-->
    <!--        min-height="200px"-->
    <!--        color="white"-->
    <!--        padding="16px"-->
    <!--        border-radius="8px"-->
    <!--      >-->
    <!--        DEBUG:-->
    <!--        <br>-->
    <!--        remaining calories: {{ Object.values(form || {}).reduce((acc, curr) => acc + (isNaN(curr.caloriesNeedPercent) ? 0 : Number(curr.caloriesNeedPercent) ), 0) }} / 110-->
    <!--      </c-box>-->
    <!--    </c-box>-->

    <c-flex
      width="100%"
      flex-direction="column"
      margin-top="16px"
    >
      <!-- trigger box shadow on [[250318]] if not intersecting -->
      <Observer
        root-margin="-350px 0px 0px 0px"
        @on-change="onChange"
      />
      <c-box
        v-for="(_step, _i) in constants.steps"
        :key="_step.value"
        box-shadow="rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
        border-radius="12px"
        background-color="#FFF"
        :margin-top="_i === 0 ? '8px' : '24px'"
      >
        <c-flex
          width="100%"
          justify-content="space-between"
          align-items="center"
          padding-inline="30px"
          padding-block="10px"
          border-bottom="1px solid #C4C4C4"
          background-color="#FFFCDD66"
        >
          <c-text
            font-size="28px"
            font-weight="600"
            color="primary.400"
          >
            {{ _step.label }}
          </c-text>
          <c-flex
            align-items="center"
            gap="6px"
            color="primary.400"
          >
            Skip jam makan 
            <c-box
              :cursor="!isProfilGiziValid ? 'not-allowed' : 'pointer'"
              @click="onToggleSkip(_step.value)"
            >
              <c-checkbox
                size="lg"
                variant-color="primary"
                :pointer-events="'none'"
                :is-checked="form[_step.value]?.isSkipped"
                :is-disabled="!isProfilGiziValid"
              />
            </c-box>
          </c-flex>
        </c-flex>
        <c-box
          padding="16px"
          :opacity="form[_step.value]?.isSkipped ? '0.5' : '1'"
        >
          <c-grid
            width="100%"
            template-columns="repeat(4, 1fr)"
            gap="16px"
          >
            <FormTimeClock
              v-model="form[_step.value].startTime"
              label="Jam Mulai Makan"
              is-required
              manual-input
              :close-on-complete="false"
              :is-disabled="form[_step.value]?.isSkipped || !isProfilGiziValid"
              :is-invalid="isInvalidField($v.form[_step.value].startTime)"
              :invalid-text="parseErrors('Jam Mulai Makan', $v.form[_step.value].startTime)"
              @blur="$v.form[_step.value].startTime.$touch"
            />
            <FormTimeClock
              v-model="form[_step.value].endTime"
              label="Jam Akhir Makan"
              is-required
              manual-input
              :close-on-complete="false"
              :is-disabled="form[_step.value]?.isSkipped || !isProfilGiziValid"
              :is-invalid="isInvalidField($v.form[_step.value].endTime)"
              :invalid-text="parseErrors('Jam Akhir Makan', $v.form[_step.value].endTime)"
              @blur="$v.form[_step.value].endTime.$touch"
            />
            <FormInput
              v-model="form[_step.value].caloriesNeedPercent"
              type="number"
              label="Kebutuhan Jumlah Kalori"
              placeholder="Masukkan alokasi % kalori untuk waktu makan ini"
              is-required
              :is-disabled="form[_step.value]?.isSkipped || !isProfilGiziValid"
              right-element="%"
              custom-padding-right-input="50px"
              :helper-text="infoTextRemainingCalories"
              helper-text-type="info"
              helper-text-color="#888"
              is-helper
              :is-invalid="!isValidCaloriesNeedPercent || isInvalidField($v.form[_step.value].caloriesNeedPercent)"
              :invalid-text="isValidCaloriesNeedPercent ? parseErrors('Jumlah Kalori', $v.form[_step.value].caloriesNeedPercent, customMessageErrors) : `Kebutuhan jumlah kalori tidak boleh melebihi 110%`"
              @blur="$v.form[_step.value].caloriesNeedPercent.$touch"
            />
            <FormInput
              v-model="form[_step.value].caloriesAmount"
              type="number"
              label="Kkal - Jumlah Kalori"
              placeholder="Jumlah Kalori"
              is-required
              is-disabled
              right-element="Kkal"
            />
          </c-grid>

          <c-box
            v-if="!form[_step.value].isSkipped"
            margin-bottom="16px"
          >
            <Info
              variant="info"
              text="Daftar golongan makanan di bawah ini opsional."
            />
          </c-box>
          <c-flex
            v-if="(!form[_step.value].isSkipped && remainingTotalMealCompositionCalories(_step.value) && remainingTotalMealCompositionCalories(_step.value) < 0) || (!form[_step.value].isSkipped && getIsValidTotalMacroNutrient === -1)"
            gap="16px"
            margin-bottom="16px"
          >
            <Info
              v-if="!form[_step.value].isSkipped && remainingTotalMealCompositionCalories(_step.value) && remainingTotalMealCompositionCalories(_step.value) < 0"
              variant="warning"
              :text="`Porsi yang dimasukkan melebihi kebutuhan jumlah kalori sebesar ${parseFloatToFixed2(Math.abs((remainingTotalMealCompositionCalories(_step.value))), 2)}`"
            />
            <Info
              v-if="!form[_step.value].isSkipped && getIsValidTotalMacroNutrient === -1"
              variant="warning"
              text="Zat gizi makro yang dimasukkan melebihi kebutuhan"
            />
          </c-flex>

          <FormMealComposition 
            :meal-time="_step.value"
            :menus="form[_step.value].mealComposition"
            :is-disabled="form[_step.value].isSkipped || !isProfilGiziValid"
            :remaining-calories="remainingTotalMealCompositionCalories(_step.value)"
            @update:menus="(val) => onChangeMenus(val, _step.value)"
          />
        </c-box>
      </c-box>
    </c-flex>

    <!-- MODAL -->
    <ModalSimpleInfo
      :is-open="isOpenModalSuccessSaveData"
      :image="require('@/assets/images/image-question.svg')"
      title="Data Rencana Makan berhasil disimpan"
    >
      <template #footer>
        <c-flex
          gap="20px"
          width="100%"
          padding="0 24px"
          margin-bottom="24px"
        >
          <BaseButton
            :right-svg-icon="require('@/assets/icons/icon-circle-check.svg')"
            right-svg-icon-color="white"
            color="primary"
            rounded="1000px"
            width="100%"
            @click="
              $router.push({
                ...$route,
                name: 'nutri.meal-plan.menu-recommendation.detail',
                params: {
                  bypass: 1,
                }
              })
            "
          >
            Oke
          </BaseButton>
        </c-flex>
      </template>
    </ModalSimpleInfo>

    <ModalSimpleInfo
      :is-open="isOpenModalFailedSaveData"
      :image="require('@/assets/images/image-question.svg')"
      title="Ups, Gagal Menyimpan Data"
      description="Mohon maaf, sepertinya terdapat kesalahan data atau data belum terisi semua. Mohon untuk mengecek ulang data anda."
    >
      <template #footer>
        <c-flex
          gap="20px"
          width="100%"
          padding="0 24px"
          margin-bottom="24px"
        >
          <BaseButton
            :right-svg-icon="require('@/assets/icons/icon-circle-check.svg')"
            right-svg-icon-color="white"
            color="primary"
            rounded="1000px"
            width="100%"
            @click="isOpenModalFailedSaveData = false"
          >
            Konfirmasi
          </BaseButton>
        </c-flex>
      </template>
    </ModalSimpleInfo>
  </c-box>
</template>

<script>
import _ from 'lodash'
import Observer from 'vue-intersection-observer'
import FormInput from '@/views/client/kuisioner/forms/form-input-2'
import FormTimeClock from '@/views/client/kuisioner/forms/form-time-clock.vue'
import TabsMealPlan from '@/components/meal-plan/_widgets/tab-meal-plan.vue'
import BaseButton from '@/components/elements/base-button.vue'
import FormMealComposition from '@/components/meal-plan/_widgets/form-meal-composition'
import Info from '@/components/info.vue'
import { reqNutriMealPlan, reqNutri_mealPlans_menuRecommendation_isSkip } from '@/requests/dietela-api/nutritionist/meal-plans'
import { requiredIf, minValue, maxValue } from 'vuelidate/lib/validators'
import { mapGetters, mapMutations } from 'vuex'
import { isInvalidField } from '@/utils/vuelidate-helpers/is-invalid-field'
import { parseErrors } from '@/utils/vuelidate-helpers/parse-errors'
import ModalSimpleInfo from '@/components/elements/modal-simple-info.vue'
import { CFlex } from '@chakra-ui/vue'
import { tabsMealPlan, mealPlanSteps, mealPlansConstant } from '@/constants/meal-plans'
import { isAllFormValid } from '@/components/meal-plan/_utils'
import { parseFloatToFixed2 } from '@/utils/other'
import CardInfoSimpleNutritionalProperty
  from '@/components/meal-plan/_widgets/card-info-simple-nutritional-property.vue'
import { parseFrom } from '@/components/meal-plan/_widgets/card-info-simple-nutritional-property.utils'
import lt from '@/utils/vuelidate-custom-validator/lt-time'
import gt from '@/utils/vuelidate-custom-validator/gt-time'
import greaterThanZero from '@/utils/vuelidate-custom-validator/greater-than-zero'
import currency from 'currency.js'

export default {
  components: {
    CardInfoSimpleNutritionalProperty,
    CFlex,
    ModalSimpleInfo,
    FormInput,
    FormTimeClock,
    TabsMealPlan,
    BaseButton,
    Info,
    Observer,
    FormMealComposition,
  },
  props: {
    draft: {
      type: [Object, null],
      default: null,
    },
    preview: {
      type: [Object, null],
      default: null,
    },
    subTabs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:validation', 'update:skip-meal-time'],
  data() {
    return {
      // isOpenModalBackToPreview: false,
      isOpenModalSuccessSaveData: false,
      isOpenModalFailedSaveData: false,
      isLoadingSave: false,
      form: {
        breakfast: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
        morningSnack: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
        lunch: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
        afternoonSnack: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
        dinner: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
        nightSnack: {
          isSkipped: false,
          startTime: '',
          endTime: '',
          caloriesNeedPercent: null,
          caloriesAmount: 0,
          remainingCaloriesTotal: null,
          mealComposition: [],
          validation: 0,
        },
      },
      isLoadingData: false,
      boxShadowSimpleNutrionalInfo: null,
    }
  },
  computed: {
    ...mapGetters({
      defaultItems: 'mealPlan/defaultItems',
      saveState: 'general/saveState',
    }),
    infoTextRemainingCalories() {
      return 'Sisa kalori makanan yang dibutuhkan: ' + this.remainingPercentTotalCaloriesNeeded.remaining + '%'
    },
    getIsValidTotalMacroNutrient() {
      // START - THIS CODE MUST SAME WITH BE
      const {
        fatRequirement,
        proteinRequirement,
        carbohydrateRequirement,
        fiberNeedsForAgeCategory,
      } = this.draft?.nutritionalIntake || {}

      const calculateNeeded = (requirement) =>
        parseFloat(
          Number(
            (mealPlansConstant.thresholdConstants.THRESHOLD / 100) *
                  requirement,
          ) || 0,
        ).toFixed(2)

      const fatNeeded = parseFloat(calculateNeeded(fatRequirement))
      const proteinNeeded = parseFloat(calculateNeeded(proteinRequirement))
      const carbohydrateNeeded = parseFloat(calculateNeeded(carbohydrateRequirement))
      const fiberNeeded = parseFloat(calculateNeeded(fiberNeedsForAgeCategory))

      const calculateNutrient = (nutrient) =>
        parseFloat(
          Object.values(this.form || {})
            ?.filter((e) => e.isSkipped === false)
            .reduce((total, e) => {
              const mealTotal = e?.mealComposition
                ?.filter((e) => e.isActive === true)
                ?.reduce(
                  (sum, current) => sum + parseFloat(current?.[nutrient] || 0),
                  0,
                )
              return total + mealTotal
            }, 0) || 0,
        ).toFixed(2)

      // Calculate total nutrients
      const fat = parseFloat(calculateNutrient('fat'))
      const protein = parseFloat(calculateNutrient('protein'))
      const carbohydrate = parseFloat(calculateNutrient('carbohydrate'))
      const fiber = parseFloat(calculateNutrient('fiber'))

      return fat > fatNeeded ||
      protein > proteinNeeded ||
      carbohydrate > carbohydrateNeeded ||
      fiber > fiberNeeded
        ? -1
        : 1

      // END - THIS CODE MUST SAME WITH BE
    },
    getSimpleNutritionalInfo() {
      return parseFrom({ ...this.preview, mealPlanSchedules: Object.values(this.form || {}) }, this.defaultItems || [], 'form')
    },
    constants() {
      return {
        steps: mealPlanSteps,
        tabsMealPlan,
      }
    },
    isValidAllMealPlanForm() {
      if (!this.draft?.mealPlanSchedules) {
        return false
      }
      if (!this.draft?.mealRecommendations) {
        return false
      }
      return !this.$v.$invalid // this.draft?.mealPlanSchedules?.every((v) => v.validation === 1)
          && this.draft?.mealRecommendations?.validation === 1
    },
    form2() {
      return this.form
    },
    customMessageErrors() {
      return {
        required: '{{fieldName}} wajib diisi',
        minValue: '{{fieldName}} tidak boleh kurang dari {{minValue.min}}%',
        maxValue: '{{fieldName}} tidak boleh lebih dari {{maxValue.max}}%',
      }
    },
    isProfilGiziValid() {
      const isAllValid = this.isAllFormValid({
        nutritionalConditions: this.draft?.nutritionalConditions && this.draft?.nutritionalConditions?.validation === 1,
        nutritionalIntake: this.draft?.nutritionalIntake && this.draft?.nutritionalIntake?.validation === 1,
        bodyConditions: this.draft?.bodyConditions && this.draft?.bodyConditions?.validation === 1,
        targetAndSuggestions: this.draft?.targetAndSuggestions && this.draft?.targetAndSuggestions?.validation === 1,
      })

      return isAllValid
    },
    isFormInvalid() {
      return this.$v.form.$invalid
    },
    totalEnergyNeeded() {
      return this.preview?.nutritionalConditions?.totalEnergyNeeded || 0
    },
    remainingPercentTotalCaloriesNeeded() {
      const CALORIES_NEEDED = 100 // total calories
      const THRESHOLD = 10 // + 10% threshold for total calories
      return {
        remaining: currency(CALORIES_NEEDED)
          .subtract(this.form.breakfast.caloriesNeedPercent)
          .subtract(this.form.morningSnack.caloriesNeedPercent)
          .subtract(this.form.lunch.caloriesNeedPercent)
          .subtract(this.form.afternoonSnack.caloriesNeedPercent)
          .subtract(this.form.dinner.caloriesNeedPercent)
          .subtract(this.form.nightSnack.caloriesNeedPercent),
        remainingWithThreshold: currency(CALORIES_NEEDED + THRESHOLD)
          .subtract(this.form.breakfast.caloriesNeedPercent)
          .subtract(this.form.morningSnack.caloriesNeedPercent)
          .subtract(this.form.lunch.caloriesNeedPercent)
          .subtract(this.form.afternoonSnack.caloriesNeedPercent)
          .subtract(this.form.dinner.caloriesNeedPercent)
          .subtract(this.form.nightSnack.caloriesNeedPercent),
      }
    },
    isValidCaloriesNeedPercent() {
      if (this.remainingPercentTotalCaloriesNeeded.remainingWithThreshold >= 0) {
        return true
      }
      return false
    },
    iconCloud() {
      switch (this.saveState) {
        case true:
          return {
            icon: require('@/assets/icons/icon-cloud-done.svg'),
            text: 'Semua perubahan telah disimpan',
            state: 'success',
          }
        case false:
          return {
            icon: require('@/assets/icons/icon-cloud-off.svg'),
            text: 'Koneksi terputus, perubahan tidak tersimpan',
            state: 'failed',
          }
        default:
          return {
            icon: require('@/assets/icons/icon-sync.svg'),
            text: 'Loading...',
            state: 'loading',
          }
      }
    },
  },
  watch: {
    form: {
      async handler() {
        const mealTimesValidations = this.constants.steps.map((it) => {
          const remainingCaloriesTotal = this.remainingTotalMealCompositionCalories(it?.value)
          const validation = this.form[it?.value].isSkipped
            ? 1
            : (this.$v.form[it?.value].$invalid || remainingCaloriesTotal === null || remainingCaloriesTotal < 0 || this.getIsValidTotalMacroNutrient === -1)
              ? -1
              : 1
          
          return validation
        })

        const data = {
          form: 'meal-plan',
          validation: mealTimesValidations?.every((v) => v === 1)
            ? 1
            : -1,
        }
        this.$emit('update:validation', data)

        if (!this.isLoadingData) {
          this.setSaveState(null)
        }
      },
      deep: true,
    },
    form2: {
      handler: _.debounce(async function() {
        this.onCheckSaveDraft()
      }, 3000),
      deep: true,
    },
    'form.breakfast.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.breakfast.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
    'form.morningSnack.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.morningSnack.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
    'form.lunch.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.lunch.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
    'form.afternoonSnack.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.afternoonSnack.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
    'form.dinner.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.dinner.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
    'form.nightSnack.caloriesNeedPercent': {
      handler: _.debounce(function(val) {
        const caloriesAmount = this.getPercentOfTotal(Number(val), Number(this.totalEnergyNeeded))
        if (caloriesAmount) {
          this.form.nightSnack.caloriesAmount = caloriesAmount
        }
      }, 500),
    },
  },
  async mounted() {
    this.isLoadingData = true
    if (!!this.preview?.mealPlanSchedules && this.preview?.mealPlanSchedules.length > 0) {
      this.form.breakfast = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'breakfast')
      this.form.morningSnack = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'morningSnack')
      this.form.lunch = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'lunch')
      this.form.afternoonSnack = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'afternoonSnack')
      this.form.dinner = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'dinner')
      this.form.nightSnack = this.preview?.mealPlanSchedules.find((it) => it.mealTime === 'nightSnack')
      this.$v.$touch()
    }

    if (this.defaultItems.length === 0) {
      await this.getDefaultItems()
    }

    this.form = Object.entries(this.form || {}).reduce((acc, [key, value]) => {
      let mealComposition = this.defaultItems.map((it) => {
        const find = value.mealComposition.find((el) => el.foodGroup === it.foodGroup)
        const resultCalc = this.calculationNutritionalPropertiesByPortion({ ...find, raw: {
          calory: it.calory,
          carbohydrate: it.carbohydrate,
          fat: it.fat,
          fiber: it.fiber,
          protein: it.protein,
        } })

        return {
          foodGroup: find?.foodGroup ?? it?.foodGroup,
          foodGroupMealGlossaries: find?.foodGroupMealGlossaries ?? it?.foodGroupMealGlossaries,
          portion: find?.portion ?? '',
          portionDecimal: find?.portionDecimal ?? 0,
          carbohydrate: resultCalc.carbohydrate ?? null,
          fat: find?.fat ?? null,
          fiber: find?.fiber ?? null,
          calories: find?.calories ?? null,
          protein: find?.protein ?? null,
          calory: find?.calory ?? null,
          mealItems: find?.mealItems ?? [],
          additionalMealItems: find?.additionalMealItems ?? [],
          defaultItems: it?.item,
          isActive: find ? true : false,
          // raw data from API
          raw: {
            carbohydrate: it?.carbohydrate,
            fat: it?.fat,
            fiber: it?.fiber,
            calory: it?.calory,
            protein: it?.protein,
          },
          order: find?.order ?? null,
        }
      })

      mealComposition = mealComposition.sort((a, b) => {
        if (a?.isActive && !b?.isActive) return -1
        if (!a?.isActive && b?.isActive) return 1
        return a?.order - b?.order
      })

      acc[key] = { ...value, mealComposition }
      return acc
    }, {})

    setTimeout(() => {
      this.isLoadingData = false
      this.setSaveState(true)
    }, 1000)
  },
  methods: {

    parseFloatToFixed2,
    isAllFormValid,
    ...mapMutations({
      setSaveState: 'general/setSaveState',
      setEditValidation: 'mealPlan/setEditValidation',
    }),
    onChange(state) {
      if (state.isIntersecting) {
        this.boxShadowSimpleNutrionalInfo = null
      } else {
        this.boxShadowSimpleNutrionalInfo = '0px 9px 6px -6px rgba(0, 0, 0, 0.25), 10px 0px 0px 0px white, -10px 0px 0px 0px white'
      }
    },
    calculationNutritionalPropertiesByPortion(data) {
      const calc = (dataNutritional_) => {
        let result = data.portionDecimal ? (parseFloat(data.portionDecimal) * parseFloat(dataNutritional_)) : null
        if (result && !Number.isInteger(result)) result = result.toFixed(2)
        return result
      }
      return {
        carbohydrate: calc(data?.raw?.carbohydrate),
        fat: calc(data?.raw?.fat),
        fiber: calc(data?.raw?.fiber),
        calories: calc(data?.raw?.calory),
        protein: calc(data?.raw?.protein),
      }
    },
    isInvalidField,
    parseErrors,
    ...mapMutations({
      setDefaultItems: 'mealPlan/setDefaultItems',
    }),
    async onToggleSkip(value) {
      if (this.isProfilGiziValid) {
        const isSkipped = !this.form[value]?.isSkipped
        this.form[value].isSkipped = isSkipped
  
        if (isSkipped) {
          this.form[value].startTime = ''
          this.form[value].endTime = ''
          this.form[value].caloriesNeedPercent = null
          this.form[value].caloriesAmount = null
          this.form[value].mealComposition = this.form[value].mealComposition.map((it) => {
            return {
              ...it,
              isActive: false,
            }
          })
        }

        const payload = {
          clientId: this.$route.params.clientId,
          programId: this.$route.params.programId,
          month: this.$route.params.month,
          isSkip: isSkipped ? 1 : -1,
          mealTime: value,
        }
        await reqNutri_mealPlans_menuRecommendation_isSkip(this.$store.getters.axios, payload)
        this.$emit('update:skip-meal-time')
      }
    },
    getPercentOfTotal(percent, total) {
      return parseFloat((percent / 100) * total).toFixed(2)
    },
    async getDefaultItems() {
      try {
        const res = await reqNutriMealPlan.getDefaultItem(this.$store.getters.axios)
        await this.setDefaultItems(res.data?.data)
      } catch (err) {
        //
      }
    },
    onChangeMenus(menus, step) {
      let order = 1
      const mealComposition = [...menus].map((it) => {
        if (it?.isActive) {
          it.order = order
          order++
        } else {
          it.order = null
        }
        
        return {
          ...it,
        }
      })

      this.form[step].mealComposition = mealComposition
    },
    onCheckSaveDraft() {
      if (!this.saveState && !this.isLoadingData && this.isProfilGiziValid) {
        this.onSaveDraft()
      }
    },
    async onSaveDraft(confirm = null) {
      try {
        this.isLoadingSave = true
        this.setSaveState(null)

        // Mapping of foodGroup to order meal compoisition
        const foodGroupOrder = this.defaultItems.map((it) => it?.foodGroup)
          
        let mealPlanSchedule = Object.keys(this.form).map((key) => {
          // Filter and pick only active and required properties
          const filteredMealComposition = _.map(
            _.filter(this.form[key].mealComposition, { isActive: true }),
            (it) => _.pick(it, [
              'additionalMealItems',
              'calories',
              'carbohydrate',
              'fat',
              'fiber',
              'protein',
              'foodGroup',
              'foodGroupMealGlossaries',
              'mealItems',
              'portion',
              'portionDecimal',
              'order',
            ]),
          )
          
          // Sort meal composition by food group order
          const sortedMealComposition = filteredMealComposition.sort((a, b) => {
            return (
              foodGroupOrder.indexOf(a.foodGroup) - foodGroupOrder.indexOf(b.foodGroup)
            )
          })

          const remainingCaloriesTotal = this.remainingTotalMealCompositionCalories(key)
          const validation = this.form[key].isSkipped
            ? 1
            : (this.$v.form[key].$invalid || remainingCaloriesTotal === null || remainingCaloriesTotal < 0 || this.getIsValidTotalMacroNutrient === -1)
              ? -1
              : 1

          return {
            ...this.form[key],
            mealTime: key,
            mealComposition: sortedMealComposition,
            validation,
          }
        })

        const payload = {
          clientId: this.$route.params.clientId,
          programId: this.$route.params.programId,
          month: this.$route.params.month,
          mealPlanSchedules: mealPlanSchedule,
        }
        await reqNutriMealPlan.updateMealPlanDraft(this.$store.getters.axios, { payload })
        this.$v.$touch()
        
        this.setSaveState(true)
        if (confirm) {
          this.isOpenModalSuccessSaveData = true
        }
        const isInvalidValidation = mealPlanSchedule.some((it) => it?.validation !== 1)
        this.setEditValidation({
          routeName: this.$route.name,
          validation: isInvalidValidation ? -1 : 1,
        })
      } catch (err) {
        this.setSaveState(false)
        this.isOpenModalFailedSaveData = true
      } finally {
        this.isLoadingSave = false
      }
    },
    totalMealCompositionCalories(mealTime) {
      let calory = 0
      this.form[mealTime].mealComposition.forEach((it) => {
        if (it?.calories && it?.isActive) {
          calory += Number(it?.calories)
        }
      })
      return calory
    },
    remainingTotalMealCompositionCalories(mealTime) {
      const totalCalories = this.totalMealCompositionCalories(mealTime)
      if (this.form[mealTime].caloriesAmount && totalCalories) {
        return Number(this.form[mealTime].caloriesAmount) - totalCalories
      }
      return null
    },
  },
  validations() {
    return {
      form: {
        breakfast: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
        morningSnack: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
        lunch: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
        afternoonSnack: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
        dinner: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
        nightSnack: {
          startTime: {
            required: requiredIf((model) => !model.isSkipped),
            ltTime: lt('endTime', 'Jam Akhir Makan'),
          },
          endTime: {
            required: requiredIf((model) => !model.isSkipped),
            gtTime: gt('startTime', 'Jam Awal Makan'),
          },
          caloriesNeedPercent: {
            required: requiredIf((model) => !model.isSkipped),
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          mealComposition: {
            required: requiredIf((model) => !model.isSkipped),
            $each: {
              portionDecimal: {
                required: requiredIf((model) => model.isActive),
                greaterThanZero,
              },
            },
          },
        },
      },
    }
  },
}
</script>

<style>

</style>